module.exports = __webpack_public_path__ + "img/Davivienda_logo.ac94b0a9.png";